import { useState, type FormEvent } from "react";
import { useNavigate } from "react-router-dom";
import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../lib/firebase";
import { api } from "../lib/api";

/**
 * Owners/managers/admins sign in with email+password on desktop.
 * (Customers use phone OTP in the Android app.)
 */
export function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  async function submit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await signInWithEmailAndPassword(auth, email, password);
      await api("/users/bootstrap", { method: "POST" });
      await auth.currentUser?.getIdToken(true);
      navigate("/");
    } catch (err) {
      setError(err instanceof Error ? err.message : "ورود ناموفق بود");
    } finally {
      setBusy(false);
    }
  }

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      sx={{
        p: 2,
        background:
          "radial-gradient(1100px 500px at 100% -10%, rgba(14,107,92,0.10), transparent 60%)," +
          "radial-gradient(900px 500px at -10% 110%, rgba(184,134,11,0.10), transparent 55%)," +
          "#F7F6F2",
      }}
    >
      <Card sx={{ width: 420, maxWidth: "100%", p: 1, boxShadow: "0 10px 40px rgba(29,28,24,0.08)" }}>
        <CardContent sx={{ p: { xs: 3, sm: 5 } }}>
          <Stack alignItems="center" spacing={0.5} mb={4}>
            <Box
              sx={{
                width: 56,
                height: 56,
                borderRadius: 3,
                bgcolor: "rgba(14,107,92,0.10)",
                color: "primary.main",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                mb: 1,
              }}
            >
              <Typography variant="h4" fontWeight={800} lineHeight={1}>
                ت
              </Typography>
            </Box>
            <Typography variant="h4" color="primary.main" fontWeight={800}>
              تالار
            </Typography>
            <Typography color="text.secondary" variant="body2">
              پنل مدیریت تالارهای عروسی
            </Typography>
          </Stack>
          <form onSubmit={submit}>
            <TextField
              label="ایمیل"
              type="email"
              fullWidth
              margin="normal"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoFocus
              required
            />
            <TextField
              label="رمز عبور"
              type="password"
              fullWidth
              margin="normal"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            {error && (
              <Alert severity="error" sx={{ mt: 1.5 }}>
                {error}
              </Alert>
            )}
            <Button
              type="submit"
              variant="contained"
              size="large"
              fullWidth
              disabled={busy}
              sx={{ mt: 3, py: 1.2 }}
            >
              {busy ? "در حال ورود…" : "ورود"}
            </Button>
          </form>
        </CardContent>
      </Card>
    </Box>
  );
}
